import { Component,EventEmitter,Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-careers-navcard',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './careers-navcard.component.html',
  styleUrl: './careers-navcard.component.scss'
})
export class CareersNavcardComponent {
@Output() close = new EventEmitter<void>();

constructor(private router: Router) {}

  closeCard() {
    this.close.emit();
  }

    navigateTo(path: string) {
    this.close.emit(); 
     this.closeCard();
    this.router.navigate([`/${path}`]);
   
  }
}
